export default __webpack_public_path__ + "static/media/marketplace.91a88e36.svg";